import {CUSTOM_PRESET, DEFAULT_PRESET, presetRange, applyCustom, buildPeriod} from '@utils/dashboard/period';

// Period filter state shared by all Dashboard pages
const initialRange = presetRange(DEFAULT_PRESET);

export const state = {
  preset: DEFAULT_PRESET,
  start: initialRange.start,
  end: initialRange.end,
};

export const getters = {
  period(state) {
    return buildPeriod(state.start, state.end, state.preset);
  },
};

export const mutations = {
  setPreset(state, preset) {
    const range = presetRange(preset);
    state.preset = preset;
    state.start = range.start;
    state.end = range.end;
  },
  setRange(state, {start, end}) {
    state.preset = CUSTOM_PRESET;
    state.start = start;
    state.end = end;
  },
};

export const actions = {
  setPreset({commit}, preset) {
    commit('setPreset', preset);
  },
  applyCustom({commit}, {start, end}) {
    const range = applyCustom(start, end);
    if (range) {
      commit('setRange', range);
    }
    return range;
  },
  // Recomputes the active preset relative to today; custom ranges stay unchanged
  refreshPreset({state, commit}) {
    if (state.preset !== CUSTOM_PRESET) {
      commit('setPreset', state.preset);
    }
  },
};
